export const chatRoutes = {
  chats: () =>
    '/chats',
  thread: {
    detail: (id: number | string) =>
      `${chatRoutes.chats()}/${id}`,
    info: (id: number | string) =>
      `${chatRoutes.thread.detail(id)}/info`,
  },
  new: {
    all: () =>
      `${chatRoutes.chats()}/new`,
    generic: () =>
      `${chatRoutes.new.all()}/generic`,
    oneToOne: () =>
      `${chatRoutes.new.all()}/oneToOne`,
    ticket: () =>
      `${chatRoutes.new.all()}/ticket`,
    group: () =>
      `${chatRoutes.new.all()}/group`,
  },
};

export const chatSkeletonRoutes = {
  chats: () =>
    '/chats',
  thread: {
    detail: () =>
      `${chatSkeletonRoutes.chats()}/:id`,
    info: () =>
      `${chatSkeletonRoutes.thread.detail()}/info`,
  },
  new: {
    all: () =>
      `${chatSkeletonRoutes.chats()}/new`,
    generic: () =>
      `${chatSkeletonRoutes.new.all()}/generic`,
    oneToOne: () =>
      `${chatSkeletonRoutes.new.all()}/oneToOne`,
    ticket: () =>
      `${chatSkeletonRoutes.new.all()}/ticket`,
    group: () =>
      `${chatSkeletonRoutes.new.all()}/group`,
  },
};
